// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"34cc44f4","739":"2de8476d"}[chunkId] + ".chunk.js";
};